import { useDeleteStore } from '../../hooks';
import { ComponentDeleteModalView } from '../../components/ComponentDeleteModalView';

export const ComponentDeleteModal = () => {
  const deleteStore = useDeleteStore();

  return <ComponentDeleteModalView {...deleteStore} />;
};
